import { Box, Tab, Tabs } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import useEvents from "../../../hooks/useEvents";
import FormFill from "../formFill/FormFill";
import Spinner from "../spinner/spinner";
import TabPanel from "../TabPanel/TabPanel";

const FormDialog = () => {
   const [value, setValue] = useState(0);

   const handleChange = (_, newValue) => {
      setValue(newValue);
   };

   const {
      events: { openForm, createLoading },
   } = useSelector((state) => state);

   const { closeEventsForm } = useEvents();

   return (
      <Dialog open={openForm} onClose={closeEventsForm}>
         <DialogTitle>Church Event</DialogTitle>
         <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={value} onChange={handleChange}>
               <Tab label="FormFill" route="/events" />
            </Tabs>
         </Box>
         <TabPanel value={value} index={0}>
            <FormFill />
         </TabPanel>

         {createLoading && <Spinner />}
      </Dialog>
   );
};

FormDialog.propTypes = {
   handleClose: PropTypes.bool,
   open: PropTypes.bool,
};

export default FormDialog;
